export default __webpack_public_path__ + "static/media/alto-las-condes.fd9bd5b2.svg";